// eslint-disable-next-line func-names
(function ($, window, Drupal) {
  Drupal.behaviors.mstArchiveBg = {
    attach() {
      $(window).on('load', () => {
        const $archivedProduction = $('.production--archive');
        const $archivedArtist = $('.artist--archive');
        const $archiveLanding = $('.archive-landing');

        if ($archivedProduction.length || $archivedArtist.length) {
          $('.site-logo').addClass('site-logo--archive-inverted');
        }

        if ($archivedProduction.length || $archivedArtist.length) {
          $('.site-container__top').addClass('bg-light');
          $('body').addClass('bg-light');
        }

        // set bg-light on page--arkiv
        if ($('.site-container__top').hasClass('bg-light')) {
          $('body').addClass('bg-light');
        }

        if ($archiveLanding.length) {
          const $focusTitle = $('.main-focus__title div').text();
          $('.main-focus .simple-card__title--prefix').text($focusTitle);
        }
      });
    },
  };
}(jQuery, window, Drupal));
